import { Components, Theme } from '@mui/material/styles';

export const muiFormControlLabelOverride: Components<
  Omit<Theme, 'components'>
>['MuiFormControlLabel'] = {
  styleOverrides: {
    root: {
      marginRight: '0px',
      fontSize: '12px',
      '& .MuiFormControlLabel-label': {
        fontSize: '1rem' // or '0.875rem', '1.2em', etc.
      }
    }
  }
};

// Add the InputLabel override
export const muiInputLabelOverride: Components<Omit<Theme, 'components'>>['MuiInputLabel'] = {
  styleOverrides: {
    root: {
      fontSize: '14px'
    }
  }
};
